import FooterView from './footer-view'

export default FooterView
